import { useEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';

import { SITE_SKYPASS } from '@ecp/common/src/const/site/siteNumberConst';

import { recommendBrandListState } from '@fo-recoil/brand/atom';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import brandApi from '@fo-apis/good/brandApi';

const useRecommendBrandList = () => {
  const [recommendBrandList, setRecommendBrandList] = useRecoilState(recommendBrandListState);
  const { siteNumber } = useSiteInfo();
  const isSkypass = useMemo(() => siteNumber === SITE_SKYPASS, [siteNumber]);

  useEffect(() => {
    (async () => {
      if (recommendBrandList.length === 0 && !isSkypass) {
        const { result } = await brandApi.getRecommendationBrandList();
        setRecommendBrandList(result || []);
      }
    })();
  }, [recommendBrandList.length, setRecommendBrandList]);
  return recommendBrandList;
};
export default useRecommendBrandList;
